export type RoleSlug = string;

export interface MenuChild {
  to: string;
  title: string;
  iconClassName?: string;
}

export interface MenuItem {
  to?: string;
  title: string;
  iconClassName: string;
  roles: RoleSlug[];
  isMenuBox?: boolean;
  className?: string;
  children?: MenuChild[];
}

const usersRoles: RoleSlug[] = [
  'admin',
  'marketing-manager',
  'marketing-director',
  'sales-director',
  'sales-manager',
  'insurance-manager',
  'finance-chief',
  'callcenter-chief',
  'callcenter-supervisor',
  'callcenter-reviewer',
  'callcenter-operator',
  'callcenter-moderator',
  'technical-support',
  'partners',
];

const bidsRoles: RoleSlug[] = [...usersRoles, 'b2b-manager', 'part-supervisor'];

const exportRoles: RoleSlug[] = bidsRoles;

export const MENU_ITEMS: MenuItem[] = [
  {
    to: '/stat/online',
    title: 'Главная',
    iconClassName: 'fa fa-dashboard',
    roles: [
      'admin',
      'marketing-manager',
      'marketing-director',
      'sales-director',
      'sales-manager',
      'callcenter-chief',
      'partners',
    ],
  },
  {
    to: '/users',
    title: 'Пользователи',
    iconClassName: 'fa fa-users',
    roles: usersRoles,
  },
  {
    to: '/history',
    title: 'История',
    iconClassName: 'fa fa-university',
    roles: ['admin', 'sales-director', 'sales-manager', 'b2b-manager', 'part-supervisor', 'partners'],
  },
  {
    isMenuBox: true,
    className: 'bids',
    title: 'Заявки',
    iconClassName: 'fa fa-newspaper-o',
    roles: bidsRoles,
    children: [
      { to: '/bids/bids', title: 'Заявки', iconClassName: 'fa fa-newspaper-o' },
      { to: '/bids/fines', title: 'Возврат штрафов', iconClassName: 'fa fa-newspaper-o' },
      { to: '/bids/commissions', title: 'Отчёт по комиссиям', iconClassName: 'fa fa-newspaper-o' },
    ],
  },
  {
    to: '/reviews',
    title: 'Отзывы',
    iconClassName: 'fa fa-star-o',
    roles: usersRoles.filter((r) => r !== 'partners'),
  },
  {
    isMenuBox: true,
    className: 'marketing',
    title: 'Маркетинг',
    iconClassName: 'fa fa-files-o',
    roles: [
      'admin',
      'marketing-manager',
      'marketing-director',
      'sales-director',
      'editor',
      'translator',
    ],
    children: [
      { to: '/marketing/utm', title: 'UTM', iconClassName: 'fa fa-sitemap' },
      { to: '/marketing/promo', title: 'Промо', iconClassName: 'fa fa-phone' },
      { to: '/marketing/partners', title: 'Партнёры', iconClassName: 'fa fa-rub' },
      { to: '/marketing/promo-actions', title: 'Акции партнеров', iconClassName: 'fa fa-star-o' },
      { to: '/marketing/organization', title: 'Организации', iconClassName: 'fa fa-outdent' },
      { to: '/marketing/logs', title: 'Логи условий промоакций', iconClassName: 'fa fa-dashboard' },
      { to: '/marketing/promotions', title: 'Наши акции', iconClassName: 'fa fa-rub' },
      { to: '/marketing/handbook', title: 'Справочник партнеров', iconClassName: 'fa fa-sitemap' },
    ],
  },
  {
    isMenuBox: true,
    className: 'car',
    title: 'Справочник авто',
    iconClassName: 'fa fa-files-o',
    roles: [
      'admin',
      'sales-director',
      'sales-manager',
      'technical-support',
      'b2b-manager',
      'part-supervisor',
      'partners',
    ],
    children: [
      { to: '/car/models', title: 'Модель', iconClassName: 'fa fa-sitemap' },
      { to: '/car/marks', title: 'Марка', iconClassName: 'fa fa-automobile' },
      { to: '/car/type', title: 'Тип', iconClassName: 'fa fa-motorcycle' },
      { to: '/car/tags', title: 'Теги', iconClassName: 'fa fa-chain' },
      { to: '/car/generation', title: 'Поколение', iconClassName: 'fa fa-outdent' },
      { to: '/car/modification', title: 'Модификация', iconClassName: 'fa fa-cog' },
    ],
  },
  {
    isMenuBox: true,
    className: 'raffle',
    title: 'Розыгрыши',
    iconClassName: 'fa fa-files-o',
    roles: ['admin', 'marketing-manager', 'marketing-director', 'sales-director'],
    children: [
      { to: '/raffle/wheel-prize', title: 'Призы', iconClassName: 'fa fa-gift' },
      { to: '/raffle', title: 'Розыгрыши', iconClassName: 'fa fa-trophy' },
    ],
  },
  {
    isMenuBox: true,
    className: 'place',
    title: 'Справочник мест',
    iconClassName: 'fa fa-map-o',
    roles: [
      'admin',
      'marketing-manager',
      'marketing-director',
      'sales-director',
      'technical-support',
      'part-supervisor',
      'partners',
    ],
    children: [
      { to: '/place/cities', title: 'Город', iconClassName: 'fa fa-hospital-o' },
      { to: '/place/regions', title: 'Регион', iconClassName: 'fa fa-map-marker' },
      { to: '/place/countries', title: 'Страна', iconClassName: 'fa fa-plane' },
    ],
  },
  {
    isMenuBox: true,
    title: 'Аналитика',
    iconClassName: 'fa fa-line-chart',
    roles: [
      'admin',
      'marketing-manager',
      'marketing-director',
      'sales-manager',
      'sales-director',
      'technical-support',
      'part-supervisor',
      'partners',
    ],
    children: [
      { to: '/metrika', title: 'Аналитика', iconClassName: 'fa fa-line-chart' },
      { to: '/stat/ai-queries', title: 'Запросы AI', iconClassName: 'fa fa-dashboard' },
    ],
  },
  {
    isMenuBox: true,
    className: 'export',
    title: 'Экспорт',
    iconClassName: 'fa fa-share-square-o',
    roles: exportRoles,
    children: [
      { to: '/export/export-franchise-services', title: 'Экспорт франшизных СТО', iconClassName: 'fa fa-code' },
      { to: '/export/export-bids', title: 'Экспорт заявок', iconClassName: 'fa fa-code' },
      { to: '/export/export-rejected-bids', title: 'Экспорт отменённых заявок', iconClassName: 'fa fa-code' },
      { to: '/export/export-billing-payment', title: 'Экспорт пополнений', iconClassName: 'fa fa-code' },
      { to: '/export/export-service-payment', title: 'Экспорт сервисов', iconClassName: 'fa fa-code' },
      { to: '/export/export-carts', title: 'Экспорт корзин запчастей', iconClassName: 'fa fa-code' },
      { to: '/export/export-marketing-payment', title: 'Экспорт платежей, маркетинг', iconClassName: 'fa fa-code' },
      { to: '/export/export-billing-loyalty', title: 'Экспорт по партнеркам', iconClassName: 'fa fa-code' },
      { to: '/export/export-loyalty', title: 'Экспорт лояльности', iconClassName: 'fa fa-code' },
      { to: '/export/export-part-orders', title: 'Экспорт заказов запчастей', iconClassName: 'fa fa-code' },
      { to: '/export/export-users', title: 'Экспорт пользователей', iconClassName: 'fa fa-code' },
      { to: '/export/accrual-points', title: 'Начисление баллов', iconClassName: 'fa fa-code' },
    ],
  },
  {
    isMenuBox: true,
    className: 'callcenter',
    title: 'Коллцентр',
    iconClassName: 'fa fa-phone',
    roles: ['admin', 'marketing-manager', 'marketing-director', 'sales-director'],
    children: [
      { to: '/callcenter/center', title: 'Коллцентр', iconClassName: 'fa fa-phone' },
      { to: '/callcenter/cancelled-bids', title: 'Отменённые заявки', iconClassName: 'fa fa-dashboard' },
      { to: '/callcenter/calls-map', title: 'Звонки с карты', iconClassName: 'fa fa-phone' },
    ],
  },
  {
    isMenuBox: true,
    className: 'billing',
    title: 'Billing',
    iconClassName: 'fa fa-rub',
    roles: ['admin', 'sales-director', 'marketing-manager', 'marketing-director'],
    children: [
      { to: '/billing/billing-log', title: 'Логи', iconClassName: 'fa fa-code' },
      { to: '/billing/billing-payment', title: 'Платежные запросы', iconClassName: 'fa fa-code' },
      { to: '/billing/billing-withdrawal', title: 'Вывод средств из сервисов', iconClassName: 'fa fa-code' },
    ],
  },
  {
    isMenuBox: true,
    className: 'stat',
    title: 'Статистика',
    iconClassName: 'fa fa-bar-chart-o',
    roles: [
      'admin',
      'marketing-manager',
      'marketing-director',
      'sales-director',
      'technical-support',
      'b2b-manager',
      'part-supervisor',
      'partners',
    ],
    children: [
      { to: '/stat/count', title: 'Количество заявок', iconClassName: 'fa fa-bar-chart-o' },
      { to: '/stat/list', title: 'Статистика по сервисам', iconClassName: 'fa fa-bar-chart-o' },
      { to: '/stat/analytics', title: 'Базовая аналитика', iconClassName: 'fa fa-bar-chart-o' },
      { to: '/stat/stat-sto-list', title: 'Показы СТО', iconClassName: 'fa fa-bar-chart-o' },
    ],
  },
  {
    isMenuBox: true,
    className: 'publications',
    title: 'Публикации',
    iconClassName: 'fa fa-file-powerpoint-o',
    roles: ['admin', 'sales-director', 'sales-manager', 'marketing-director', 'marketing-manager'],
    children: [
      { to: '/publications/article', title: 'Новости', iconClassName: 'fa fa-header' },
      { to: '/publications/categories', title: 'Категории', iconClassName: 'fa fa-outdent' },
      { to: '/publications/tags', title: 'Теги', iconClassName: 'fa fa-chain' },
      { to: '/publications/press', title: 'Пресса о нас', iconClassName: 'fa fa-newspaper-o' },
      { to: '/publications/stories', title: 'Сторис', iconClassName: 'fa fa-instagram' },
    ],
  },
  {
    to: '/verification',
    title: 'Верификация',
    iconClassName: 'fa fa-share-square-o',
    roles: [
      'admin',
      'sales-director',
      'sales-manager',
      'finance-chief',
      'callcenter-chief',
      'callcenter-supervisor',
      'callcenter-moderator',
      'technical-support',
      'b2b-manager',
      'part-supervisor',
    ],
  },
  {
    to: '/works',
    title: 'Услуги',
    iconClassName: 'fa fa-wrench',
    roles: [
      'admin',
      'marketing-manager',
      'marketing-director',
      'sales-director',
      'sales-manager',
      'technical-support',
      'b2b-manager',
      'part-supervisor',
      'partners',
    ],
  },
  {
    isMenuBox: true,
    className: 'seo',
    title: 'SEO',
    iconClassName: 'fa fa-search',
    roles: ['admin', 'marketing-manager', 'marketing-director', 'sales-director', 'editor'],
    children: [
      { to: '/seo/pages', title: 'Страницы', iconClassName: 'fa fa-folder-open' },
      { to: '/seo/cities', title: 'Города', iconClassName: 'fa fa-folder-open' },
      { to: '/seo/brands', title: 'Марки', iconClassName: 'fa fa-folder-open' },
      { to: '/seo/models', title: 'Модели', iconClassName: 'fa fa-folder-open' },
      { to: '/seo/works', title: 'Услуги', iconClassName: 'fa fa-folder-open' },
    ],
  },
  {
    isMenuBox: true,
    className: 'parts',
    title: 'Запчасти',
    iconClassName: 'fa fa-cog',
    roles: ['admin', 'sales-manager', 'sales-director', 'technical-support', 'b2b-manager', 'part-supervisor'],
    children: [
      { to: '/parts/parts', title: 'Заказы', iconClassName: 'fa fa-cog' },
      { to: '/parts/markups', title: 'Наценки', iconClassName: 'fa fa-rub' },
      { to: '/parts/carts', title: 'Корзины', iconClassName: 'fa fa-rub' },
      { to: '/parts/points', title: 'ПВЗ', iconClassName: 'fa fa-university' },
    ],
  },
  {
    to: '/notifications',
    title: 'Уведомления',
    iconClassName: 'fa fa-phone',
    roles: [
      'admin',
      'sales-manager',
      'sales-director',
      'marketing-manager',
      'marketing-director',
      'technical-support',
      'editor',
      'b2b-manager',
      'part-supervisor',
    ],
  },
  {
    isMenuBox: true,
    className: 'insurance',
    title: 'Страхование',
    iconClassName: 'fa fa-wrench',
    roles: ['admin', 'sales-director', 'technical-support'],
    children: [
      { to: '/insurance/agents', title: 'Агенты', iconClassName: 'fa fa-phone' },
      { to: '/insurance/insurance', title: 'Заявки на страхование', iconClassName: 'fa fa-files-o' },
      { to: '/insurance/companies', title: 'Страховые компании', iconClassName: 'fa fa-university' },
    ],
  },
  {
    to: '/crypto',
    title: 'Crypto',
    iconClassName: 'fa fa-cog',
    roles: ['admin'],
  },
  {
    isMenuBox: true,
    className: 'loyalty',
    title: 'Лояльность',
    iconClassName: 'fa fa-heart',
    roles: [
      'admin',
      'sales-manager',
      'sales-director',
      'marketing-manager',
      'marketing-director',
      'technical-support',
    ],
    children: [
      { to: '/loyalty/levels', title: 'Уровни лояльности', iconClassName: 'fa fa-trophy' },
      { to: '/loyalty/privileges', title: 'Привилегии', iconClassName: 'fa fa-bookmark-o' },
    ],
  },
];

export function getMenuItemsByRoles(rolesObject: Record<string, unknown> | unknown[] | null | undefined): MenuItem[] {
  if (!rolesObject || typeof rolesObject !== 'object') return [];
  const roles = Array.isArray(rolesObject) ? rolesObject.map(String) : Object.keys(rolesObject);
  return MENU_ITEMS.filter((item) => roles.some((role) => item.roles.includes(role)));
}
